import { accountsRoyaltyMutations } from "./accounts/mutations";
import { contractsRoyaltyMutations } from "./contracts/mutations";
import { dealsRoyaltyMutations } from "./deals/mutations";
import { recoupableMutations } from "./recoupable/mutations";
import { statementMutations } from './statement/mutations';
import { RoyaltyModulePluginStore } from "./plugin-store";

export const mutations = {
  ...accountsRoyaltyMutations,
  ...contractsRoyaltyMutations,
  ...dealsRoyaltyMutations,
  ...statementMutations,
  ...recoupableMutations,
  ...RoyaltyModulePluginStore.mutations
};
